import { useContext } from 'react';

import { FilterContext } from '../contexts';

// ----------------------------------------------------------------------

const useFilter = () => {
  const context = useContext(FilterContext);

  if (!context) throw new Error('Filter context must be use inside FilterProvider');

  return context;
};

export default useFilter;
